<template>
  <div class="card-tv">
    <div class="body-card-tv-fixed" id="body-card-tv-fixed">
      <div class="header-card-tv" :style="borderBottomColorHeaderCards">
        <h4>{{this.product.family}}</h4>
      </div>
      <div class="body-card-tv">
        <div class="images-area">
          <img src="../assets/samsung-indication.png" :class="{showIndication: this.perfectForYou}" />
          <img src="../assets/cost-benefit.png" :class="{showCostBenefit: this.bestCostBenefit}" />
          <img :src="this.product.image.src" class="tv-image"
            :class="{paddingTvImage: !this.product.bestCostBenefit && !this.product.perfectForYou}" />
        </div>
        <h2 class="gap">{{this.product.displayName}}</h2>
        <div class="inner-text">
          <button :id="'btn_' + this.product.displayName + '_comprar'" class="button primary gap"
            v-on:click="onClickBuy()">Quero essa</button>
          <button :id="'btn_' + this.product.displayName + '_saiba'" class="button link"
            v-on:click="onClickLearnMore()">Saiba mais</button>
        </div>
      </div>
    </div>
    <div class="footer-card-tv">
      <!-- <a @click="goToShopkeepers">Ou compre na sua loja de preferência</a> -->
    </div>

    <div v-for="(value, key, index) in mapping" :key="key" class="separator-wrapper">
      <div class="separator gray-line" :class="{ 'mt-8': index > 0}">
        <div class="info section-title" :class="{ open: visibleSections[key] }" v-on:click="toggleVisible(key)">
          {{value.name}}
          <ChevronDownIcon class="chevron" />
        </div>
      </div>

      <div v-for="(spec, specIndex) in value.specs" :key="spec" class="info"
        :class="{ inactive: !visibleSections[key] && !highlights.includes(spec), 'gray-line': specIndex % 2 !== 0 }">
        <Spec :name="spec" :content="product.specs[spec]" />
      </div>
    </div>
  </div>
</template>

<script>
import ChevronDownIcon from '../assets/chevron-down.svg'
import Spec from './Spec.vue';
import { mapping } from '../constants/specs';

export default {
  name: "CardTV",
  components: { Spec, ChevronDownIcon },
  props: [
    "sendAnalytics", 
    "product", 
    "idCardTV", 
    "perfectForYou", 
    "bestCostBenefit", 
    "visibleSections", 
    "highlights", 
    "goSmooth",
    "menuActive",
    "showOverview"
  ],
  data() {
    return {
      deveMudar: false,
      mapping,
      borderBottomColorHeaderCards: {
        borderBottom: `2px solid ${this.product.cardColor}`
      },
      menusIndex: [
        "Ambiente", 
        "Preferências", 
        "Tamanho",
        "Preco"
      ],
    }
  },
  computed: {},
  mounted() {
   
  },
  watch: {
    product: {
      handler() {
      }
    }
  },
  methods: {
    onClickLearnMore() {
      if (this.product.perfectForYou) {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'saiba-mais-' + this.product.displayName + "-perfeita-para-voce");
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_saiba`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1],
          Tag: "Perfeita para você"
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

      }
      else if (this.product.bestCostBenefit) {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'saiba-mais-' + this.product.displayName + "-melhor-custo-beneficio");
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_saiba`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1],
          Tag: "Melhor custo benefício"
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }
      else {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'saiba-mais-' + this.product.displayName);
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_saiba`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1]
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }

      window.open(this.product.pdpUrl);
    },
    onClickBuy() {

      if (this.product.perfectForYou) {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'quero-essa-' + this.product.displayName + "-perfeita-para-voce");
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_comprar`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1],
          Tag: "Perfeita para você"
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }
      else if (this.product.bestCostBenefit) {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'quero-essa-' + this.product.displayName + "-melhor-custo-beneficio");
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_comprar`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1],
          Tag: "Melhor custo benefício"
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }
      else {
        window.click_s_evar_event('o', '26', 'carrossel', 'click', 'quero-essa-' + this.product.displayName);
        window.fbq('trackCustom', 'CE_HOT');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
        });
        window.twq('event', 'tw-o2ja6-oc3xw', {});

        // Analytics João
        window.dataLayer.push({
          event: `gtm.${this.product.displayName}_comprar`,
          target: "gtm-more",
          action: "navigation",
          Menu: this.showOverview ? 'resumo' : this.menusIndex[this.menuActive - 1]
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });
      }

      this.$emit("onClickOpenForm", this.product);
    },
    toggleVisible(section) {
      this.visibleSections[section] = !this.visibleSections[section];
    },
    goToShopkeepers() {
      this.goSmooth('shop');

      window.click_s_evar_event('o', '26', 'carrossel', 'click', 'shop-parceiros-' + this.product.displayName);
      window.fbq('trackCustom', 'CE_HOT');
      window.gtag('event', 'conversion', {
        'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
      });
      window.twq('event', 'tw-o2ja6-oc3xw', {});

      // Analytics João
      window.dataLayer.push({
          event: `gtm.${this.product.displayName}`,
          target: "gtm-more",
          action: "navigation",
          menu_origem: 'Preferências-range-preco',
          menu_destino: 'Preferências-filtro',
          parametro: "Shop_parceiros",
          // label: "target-properties",
          // value: 5000,
          // noninteraction: "interaction-type",
          // TransactionID: numRandomicoUnico,
        });

      // VERIFICAR TAG
      // window.click_s_code("o", `comprar:header`);
      //   window.fbq("trackCustom", "CE_HOT");
      //   window.gtag("event", "conversion", {
      //   send_to: "AW-844810653/NxkOCKj138ICEJ2T65ID",
      // });
    }
  },
};
</script>

<style lang="scss">
.section-title {
  display: none;
  border-top: 1px solid #D7D2CB;
}
.body-card-tv-fixed{
  background: #fff;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position:relative;
  z-index: 3;
  position: sticky;
  top: 0;
}
.separator-wrapper {
  width: 100%;
}

.card-tv {
  display: flex;
  align-items: center;

  flex-direction: column;

  background-color: #FFF;

  width: 204px;

  .header-card-tv {
    height: 40px;
    width: 100%;

    border-radius: 4px 4px 0px 0px;

    background-color: #D7D2CB;

    display: flex;
    justify-content: center;
    align-items: center;

    h4 {
      font-family: $font-family-title;
    }
  }

  .body-card-tv {
    display: flex;
    flex-direction: column;
    height: 331px;
    width: 177px;

    align-items: center;
    text-align: center;
    justify-content: flex-end;

    padding: 0 5px;

    .images-area {

      display: flex;
      flex-direction: column;
      align-items: center;

      margin-top: 1rem;
      position: relative;
      padding: 0 5px;
      &::before{
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;

      }
      .paddingTvImage {
        padding-top: 2.5rem !important;
      }

      .tv-image {
        padding-top: 5px;
      }

      :nth-child(1),
      :nth-child(2) {
        display: none;
      }

      .showCostBenefit,
      .showIndication {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    h2 {
      font-family: $font-family-title;
      font-weight: bold;
      color: #2E2C2B;

      padding: 0;
    }

    button {
      width: 160px;
    }

    @media(max-width: $bp-mobile) {
      button {
        width: 127px;
      }
    }

    .link {
      margin-top: 10px;
      padding: 5px 5px;
      width: auto;
    }

    .buttonSecondary {
      margin-top: 0.5rem;
    }
  }

  .inner-text {
    padding: 0 20px;
  }

  .footer-card-tv {
    text-align: center;

    max-width: 140px;

    margin: 1rem 0;

    a {
      font-family: $font-family-default;
      font-weight: bold;

      color: $color-gray-extra-dark;
      text-decoration: underline;

      cursor: pointer;
    }
  }

  .info {
    width: 100%;
    text-align: center;
    line-height: 50px;

    sup {
      font-size: smaller;
      line-height: initial;
      vertical-align: super;
      top: 0px;
    }
  }

  .separator {
    background: #FFF;
    width: 100%;
    height: 50px;
  }

  .gray-line {
    background-color: rgba(250, 250, 250, 1);
  }
}

.gap {
  margin-top: $gap-horizontal-large-text;
}

.inactive {
  display: none;
}

@media (max-width: $bp-mobile) {
  .section-title {
    color: #2E2C2B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: $font-family-default-bold;
  }

  .separator-wrapper {
    background-color: #F7F3F0;
  }


  .mt-8 {
    margin-top: 8px;
  }

  .gray-line {
    background: #FFF !important;
  }
}
</style>
